import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/provide/auth.service';
import { CommonService } from 'src/app/provide/common.service';
declare var $

@Component({
  selector: 'app-customer-deals-service-view-particular',
  templateUrl: './customer-deals-service-view-particular.component.html',
  styleUrls: ['./customer-deals-service-view-particular.component.scss']
})
export class CustomerDealsServiceViewParticularComponent implements OnInit {
  // Debugging state variables
  private debugState: any = {};
  
  // Global error handler to catch uncaught errors
  private catchMapErrors() {
    // Use a safer approach without extending the prototype directly
    try {
      // Create a flag in window to track if we've already installed the handler
      const w = window as any;
      if (!w._safeMapInstalled) {
        const originalMap = Array.prototype.map;
        Array.prototype.map = function(...args) {
          try {
            if (this === undefined || this === null) {
              console.error('Map called on undefined or null at:', new Error().stack);
              return [];
            }
            return originalMap.apply(this, args);
          } catch (error) {
            console.error('Error in map function:', error);
            console.error('Stack trace:', error.stack);
            return [];
          }
        };
        w._safeMapInstalled = true;
      }
    } catch (error) {
      console.error('Error installing map error handler:', error);
    }
  }
  
  // Safe method to make API calls with error handling
  private safeSend(apiMethod: string, apiUrl: string, apiData: any = {}, authToken: any = 1, callback?: Function) {
    console.log(`Preparing to call ${apiMethod} on ${apiUrl}`);
    console.log('API data:', JSON.stringify(apiData));
    
    try {
      // Record the API call in debug state
      this.debugState.lastApiCall = {
        method: apiMethod,
        url: apiUrl,
        data: apiData,
        timestamp: new Date().toISOString()
      };
      
      this.commonService.showSpinner();
      
      let observable;
      
      // Determine which API method to call
      if (apiMethod === 'get') {
        observable = this.commonService.getApi(apiUrl, authToken);
      } else if (apiMethod === 'post') {
        observable = this.commonService.postApi(apiUrl, apiData, authToken);
      } else if (apiMethod === 'delete') {
        observable = this.commonService.deleteApi(apiUrl, authToken);
      } else {
        throw new Error(`Unsupported API method: ${apiMethod}`);
      }
      
      // Subscribe to the observable with proper error handling
      observable.subscribe(
        (res: any) => {
          try {
            console.log(`Received response from ${apiMethod} ${apiUrl}:`, res ? JSON.stringify(res) : 'No response');
            
            // Record the API response in debug state
            this.debugState.lastApiResponse = {
              method: apiMethod,
              url: apiUrl,
              response: res,
              timestamp: new Date().toISOString()
            };
            
            this.commonService.hideSpinner();
            
            // Call the callback function with the response if provided
            if (callback && typeof callback === 'function') {
              callback(res);
            }
          } catch (error) {
            this.commonService.hideSpinner();
            console.error(`Error processing response from ${apiMethod} ${apiUrl}:`, error);
            console.error('Stack trace:', error.stack);
          }
        },
        (err) => {
          this.commonService.hideSpinner();
          console.error(`Error calling ${apiMethod} ${apiUrl}:`, err);
          
          // Record the API error in debug state
          this.debugState.lastApiError = {
            method: apiMethod,
            url: apiUrl,
            error: err,
            timestamp: new Date().toISOString()
          };
        }
      );
    } catch (error) {
      this.commonService.hideSpinner();
      console.error(`Exception in safeSend for ${apiMethod} ${apiUrl}:`, error);
      console.error('Stack trace:', error.stack);
    }
  }

  _id: any
  isLoggedIn: any
  loggedInUserType: any
  catID: any
  UsID: any
  categoryName: any
  quantityValue: any = 1
  panelOpenState = false; //accordian open close question's and answer's
  selectedService: any
  addressId: any
  spordicType: string ;
  step = 0;
  todayDate = new Date().toISOString().split('T')[0];
  headingName: any = 'BOOKING PROVIDERS'
  linkerRouteItems: any = [
    { name: 'Home', route: '/home' },
    { name: 'Bookings', route: '/customer-service-deal-list' },
    { name: 'Bookings Providers', route: '/customer-service-deal-list' }

  ]
  timeArray = []
  valueQuantityAvailabe = 1
  isLoaded: boolean;
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }
  getcurrentdatetime(e) {
    let currentDate = new Date().toISOString().split('T')[0]
    let currentTime = new Date().getHours()
    let i = 1
    this.timeArray = []
    if (currentDate == new Date(e.target.value).toISOString().split('T')[0]) {
      for (let it = currentTime; it < 20; it++) {
        let pmAm = currentTime > 12 ? 'PM' : 'AM'

        if (currentTime < 12) {
          let t = `${currentTime}:00${pmAm} - ${currentTime + 1}:00${currentTime + 1 == 12 ? 'PM' : pmAm} `
          this.timeArray.push(t)

        }
        if (currentTime > 12) {
          let t = `${currentTime - 11}:00${pmAm} - ${currentTime - 10}:00${pmAm} `
          this.timeArray.push(t)

        }
        currentTime++
        i++
      }

    }
    else {
      let c = 8
      for (let it = c; it < 21; it++) {
        let pmAm = c > 12 ? 'PM' : 'AM'
        if (c < 12) {
          let t = `${c}:00${pmAm} - ${c + 1}:00${c + 1 == 12 ? 'PM' : pmAm} `
          this.timeArray.push(t)

        }
        if (c > 12) {
          let t = `${c - 12}:00${pmAm} - ${c - 11}:00${pmAm} `
          this.timeArray.push(t)

        }
        c++
        i++
      }
    }


  }
  isLoading: boolean = false
  prevStep() {
    this.step--;
  }
  isDiscount = false
  intrestedPrice : boolean = false
  serviceDetails = []
  constructor(private activatedroute: ActivatedRoute, private toastrService: ToastrService,public commonService: CommonService, private router: Router, public authService: AuthService, private datePipe: DatePipe, public sanatizer: DomSanitizer) {
    // Install the error handler at the beginning
    this.catchMapErrors();
    
    try {
      this.activatedroute.queryParams.subscribe((res: any) => {
        this.catID = res.categoryId;
        this.UsID = res.userId;
        this.categoryName = res.categoryName;
      });
      console.log(this.catID, "catID");

      // Safely retrieve selectedService from sessionStorage
      try {
        const serviceData = sessionStorage.getItem('selectedService');
        if (serviceData) {
          this.selectedService = JSON.parse(serviceData);
          console.log("Successfully loaded selectedService:", this.selectedService);
        } else {
          console.error("No selectedService found in sessionStorage");
          this.selectedService = null;
          this.isLoading = false;
          return;
        }
      } catch (error) {
        console.error("Error parsing selectedService from sessionStorage:", error);
        this.selectedService = null;
        this.isLoading = false;
        return;
      }

      // Only proceed if selectedService is properly loaded
      if (this.selectedService) {
        this.isLoading = true;
        
        // Set default quantity if not present
        if (!this.selectedService.quantity) {
          this.selectedService.quantity = 1;
        }
        
        // Check for discount
        if (this.selectedService.serviceId && 
            this.selectedService.dealPrice !== undefined && 
            this.selectedService.serviceId.price !== undefined && 
            this.selectedService.dealPrice != this.selectedService.serviceId.price) {
          this.isDiscount = true;
        }
        
        // Set interested price flag
        this.intrestedPrice = this.selectedService.isIntrestPriceAdded || false;
      } else {
        this.isLoading = false;
      }
      
      // Get address ID from localStorage
      this.addressId = localStorage.getItem('primaryAddressId');
      
      // Get campaign preferences from localStorage
      this.spordicType = localStorage.getItem('campainPrefrences');
    } catch (error) {
      console.error("Error in constructor:", error);
      this.isLoading = false;
    }
  }

  ngOnInit(): void {
    // Ensure error handling is initialized
    this.catchMapErrors();
    
    // Initialize all arrays that might be used in payment processing
    this.dropDownData = this.dropDownData || [];
    this.serviceList = this.serviceList || [];
    this.listAddressData = this.listAddressData || [];
    this.subServiceList = this.subServiceList || [];
    
    try {
      console.log('Starting ngOnInit method');
      
      // Store method execution state
      this.debugState.ngOnInitCalled = {
        timestamp: new Date().toISOString()
      };
      
      // Only proceed with initialization if selectedService is available
      if (!this.selectedService) {
        console.error('selectedService is undefined in ngOnInit');
        this.commonService.errorToast('Service details not available. Please go back and try again.');
        return;
      }
      
      // Add global safeguards for Array.prototype methods
      // This prevents "cannot read property 'map' of undefined" errors
      if (typeof Array.prototype.find !== 'function') {
        console.log('Adding safe polyfill for Array.prototype.find');
        Array.prototype.find = function(callback) {
          try {
            if (typeof callback !== 'function') {
              throw new TypeError('callback must be a function');
            }
            for (let i = 0; i < this.length; i++) {
              if (callback(this[i], i, this)) {
                return this[i];
              }
            }
            return undefined;
          } catch (error) {
            console.error('Error in Array.find polyfill:', error);
            return undefined;
          }
        };
      }
      
      // Load wallet data with error protection
      console.log('About to call myWallet method');
      try {
        this.myWallet();
      } catch (error) {
        console.error('Error calling myWallet from ngOnInit:', error);
      }
      
      // Initialize authentication data
      console.log('Initializing authentication data');
      this.authService.isLoggedIn.subscribe((res: any) => {
        this.isLoggedIn = res;
      });
      this.isLoggedIn = this.authService.isLogin();
      
      this.authService.loggedInUserType.subscribe((res: any) => {
        this.loggedInUserType = res;
      });
      
      // Load address if available
      console.log('Loading address data');
      if (this.addressId) {
        try {
          this.viewaddress();
        } catch (error) {
          console.error('Error calling viewaddress from ngOnInit:', error);
        }
      }

      // List addresses and calculate product price
      console.log('Calling listAddress and getTotalProductPrice');
      try {
        this.listAddress();
      } catch (error) {
        console.error('Error calling listAddress from ngOnInit:', error);
      }
      
      try {
        this.getTotalProductPrice();
      } catch (error) {
        console.error('Error calling getTotalProductPrice from ngOnInit:', error);
      }
      
      console.log('ngOnInit completed successfully');
    } catch (error) {
      console.error("Error in ngOnInit:", error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An error occurred during initialization. Please refresh the page.');
    }
  }



  userId: any;
  productDetails: any;
  productId: any;
  retailerId: any;
  imgurl: any;
  imageLinks: any

  getProduct() {
    if (this.isLoggedIn) {
      this.viewRetailerProductd()
    } else {
      this.viewRetailerProductdWithoutLogin()
    }
  }
  firstPriceSize: any = [];
  productDetailsSize: any = []
  // get retailer detail by id
  viewRetailerProductd() {
    let apiReqUrl: any = `product/viewProduct?productId=${this._id}`
    // let apiReqUrl: any = `${ApiEndPoint.productView + '?productId=' + this.productId}`
    // this.commonService.showSpinner();
    let a = this.commonService.isLoggedIn() ? 1 : 0
    this.commonService.postApi(apiReqUrl, {}, a).subscribe((res: any) => {
      if (res.responseCode == 200) {


        this.productDetails = res.result;
        this.productDetailsSize = res.result.priceSizeDetails

        this.firstPriceSize = res.result.priceSizeDetails[0]
        this.price(this.firstPriceSize.price, this.firstPriceSize.quantity, this.firstPriceSize.value, this.firstPriceSize.id, this.firstPriceSize.unit)
        this.imgurl = res.result.productImage[0]
        this.imageLinks = res["result"]["thumbnail"]
        this.commonService.hideSpinner();
        // this.router.navigate(['/edit-product'])
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    })
  }
  viewRetailerProductdWithoutLogin() {
    let apiReqUrl: any = `product/viewProduct?productId=${this._id}`
    // let apiReqUrl: any = `${ApiEndPoint.productView + '?productId=' + this.productId}`
    this.commonService.showSpinner();
    let a = this.commonService.isLoggedIn() ? 1 : 0
    this.commonService.postApi(apiReqUrl, {}, a).subscribe((res: any) => {
      if (res.responseCode == 200) {


        this.productDetails = res.result;
        this.imgurl = res.result.productImage[0]
        this.imageLinks = res["result"]["thumbnail"]
        this.commonService.hideSpinner();
        // this.router.navigate(['/edit-product'])
        // this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    })
  }



  forID(_id: any) {
    this.router.navigate(['/edit-product'], { queryParams: { _id: _id } })

  }




  changeProductimage(url: any) {
    this.imgurl = url
  }


  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  mrp: any
  quantity: any
  value: any
  unit: any
  pdId: any
  price(e: any, q: any, v: any, id, u) {
    this.mrp = e,
      this.quantity = q
    this.value = v
    this.unit = u
    this.pdId = id
  }
  imgSrc: any
  productImage: any
  serviceData: any = []

  addWishlist(id) {
    let apiReqUrl = `user/addWishListProduct?productId=${id}`
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {

        this.commonService.hideSpinner();
        this.viewRetailerProductd()
        // this.router.navigate(['/edit-product'])
        this.commonService.successToast(res.responseMessage);
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
        if (res.responseCode == 401) {
          this.router.navigate[('/login')]
        }
      }
    }, (err) => {
      this.commonService.hideSpinner()
      if (err.responseCode == 401) {
        this.router.navigate[('/login')]
      }
    })
  }
  UserDetailsData: any
  serviceDetailsArray: any = []
  // viewCategoryAvailableService(){
  //   let apiReqUrl = `v2/service/listServiceNearMe`
  //   let apiReqData = {
  //     userId : this.UsID,
  //     categoryId : this.catID
  //   }
  //   this.commonService.showSpinner();
  //   this.commonService.postApi(apiReqUrl, apiReqData, 0).subscribe((res: any) => {
  //     if (res.responseCode == 200) {
  //       
  //       this.commonService.hideSpinner();
  //       this.UserDetailsData = res.result.userDeails
  //       this.serviceDetailsArray =res.result.docs
  //       this.getTotalProductPrice()
  //       // this.commonService.successToast(res.responseMessage);
  //     } else {
  //       this.commonService.hideSpinner();
  //       this.commonService.errorToast(res.responseMessage)
  //       this.getTotalProductPrice()
  //       if (res.responseCode == 401) {
  //       }
  //     }
  //   }, (err) => {
  //     this.commonService.hideSpinner()
  //     this.getTotalProductPrice()
  //     if (err.responseCode == 401) {
  //     }
  //   })
  // }
  profileData: any = []
  viewaddress() {
    let url = `user/viewAddress?addressId=${this.addressId}`
    this.commonService.showSpinner();
    this.commonService.getApi(url, 1).subscribe((res: any) => {
      if (res["responseCode"] == 200) {
        this.commonService.hideSpinner();
        this.profileData = res["result"];

      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res["responseMessage"])
      }
    }, (err) => {
      this.commonService.hideSpinner();
      this.commonService.errorToast("Server error")
    });
  }
  navigateToserviceQuantity(qnty) {
    this.router.navigate(['/edit-address-customer'], { queryParams: { qnty: qnty, categoryId: this.catID, userId: this.userId, categoryName: this.categoryName } })
  }
  navigateToEdit(qnty) {
    this.router.navigate(['/edit-address-customer'], { queryParams: { id: this.addressId, qnty: qnty, categoryId: this.catID, userId: this.userId, categoryName: this.categoryName } })
  }
  subtotal: any = 0
  total: any = 0
  sum: any = 0
  vatValue = 0
  sumToatal = 0
  flag: boolean = true
  totalPayAmount = 0
  priceValueOfService: any = 0

  getTotalProductPrice() {
    try {
      // Reset all price-related variables
      this.sum = 0;
      this.total = 0;
      this.vatValue = 0;
      this.subtotal = 0;
      this.sumToatal = 0;
      this.totalPayAmount = 0;
      this.priceValueOfService = 0;
      
      // Only proceed if selectedService exists and has a dealPrice
      if (!this.selectedService) {
        console.warn("selectedService is undefined in getTotalProductPrice");
        return;
      }
      
      if (this.selectedService.dealPrice === undefined || this.selectedService.dealPrice === null) {
        console.warn("dealPrice is undefined in selectedService");
        return;
      }
      
      // Calculate service price
      const dealPrice = parseFloat(this.selectedService.dealPrice) || 0;
      const quantity = parseInt(this.quantityValue) || 1;
      
      this.priceValueOfService = dealPrice * quantity;
      console.log("Price of service:", this.priceValueOfService);
      
      // Calculate totals
      this.sum += this.total;
      this.subtotal = this.sum;
      this.vatValue = (15 / 100);
      this.sumToatal = (this.vatValue * this.priceValueOfService);
      this.totalPayAmount = (this.sumToatal + this.priceValueOfService);
      console.log("VAT amount:", this.sumToatal);
      console.log("Total amount to pay:", this.totalPayAmount);
    } catch (error) {
      console.error("Error in getTotalProductPrice:", error);
      this.sum = 0;
      this.priceValueOfService = 0;
      this.sumToatal = 0;
      this.totalPayAmount = 0;
    }
  }
  timeSlots: any = ''
  duration: any
  buyOrderData: any
  /***
   * @bookAService
   */
  bookService(flag: number) {
    try {
      console.log('bookService called with flag:', flag);
      
      const url = `v2/service/buyService`;

      // Double-check all required parameters with detailed logging
      if (!this.timeSlots) {
        console.error('timeSlots is undefined in bookService');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Please select a time slot');
      }
      
      if (!this.duration) {
        console.error('duration is undefined in bookService');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Please select a date');
      }
      
      if (!this.addressId) {
        console.error('addressId is undefined in bookService');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Please select an address');
      }
      
      // Validate selectedService with detailed diagnostics
      if (!this.selectedService) {
        console.error('selectedService is undefined in bookService');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Service details not available. Please refresh the page and try again.');
      }
      
      console.log('selectedService in bookService:', JSON.stringify(this.selectedService));
      
      if (!this.selectedService.serviceId) {
        console.error('serviceId is undefined in selectedService (bookService)');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Service ID not available. Please refresh the page and try again.');
      }
      
      if (!this.selectedService.serviceId._id) {
        console.error('serviceId._id is undefined in selectedService (bookService)');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Service ID not available. Please refresh the page and try again.');
      }

      if (!this.selectedService._id) {
        console.error('selectedService._id is undefined (bookService)');
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Deal ID not available. Please refresh the page and try again.');
      }

      // Create API request data with safe property access
      let apiReqData = {
        serviceId: this.selectedService.serviceId._id,
        addressId: this.addressId,
        quantity: this.selectedService.quantity || 1,
        timeSlot: this.timeSlots,
        serviceDate: this.duration,
        isDeal: true,
        dealId: this.selectedService._id,
        orderPrice: this.totalPayAmount,
        actualPrice: this.priceValueOfService,
        taxPrice: this.sumToatal
      };
      
      console.log('Creating service order with data:', JSON.stringify(apiReqData));
      
      // Only now set flag to false, right before the API call
      this.flag = false;
      
      // Set payment type in localStorage - important for the success page to know
      // this is a service booking and redirect to booking history
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('isServiceBooking', 'true');
      
      this.safeSend('post', url, apiReqData, 1, (res: any) => {
        try {
          console.log('Received bookService response:', res ? JSON.stringify(res) : 'No response');
          
          if (res && res.responseCode == 200 && res.result) {
            this.buyOrderData = res.result;
            console.log('Order created successfully:', this.buyOrderData);

            // Store the order ID for reference in case of payment issues
            if (this.buyOrderData && this.buyOrderData._id) {
              localStorage.setItem('lastOrderId', this.buyOrderData._id);
              
              if (flag == 1) {
                console.log('Calling ozhoPayment after successful order creation');
                this.ozhoPayment();
              }
              else if (flag == 2) {
                console.log('Calling walletPayment after successful order creation');
                this.walletPayment();
              }
              else if (flag == 4) {
                console.log('Calling yocoPayment after successful order creation');
                this.yocoPayment();
              }
              else if (flag == 3) {
                console.log('Calling paygatePayment after successful order creation');
                this.paygatePayment();
              }
              else {
                console.error('Invalid flag value:', flag);
                this.flag = true;
                this.commonService.hideSpinner();
                this.commonService.errorToast('Invalid payment method. Please try again.');
              }
            } else {
              console.error('buyOrderData._id is undefined after API response');
              this.flag = true;
              this.commonService.hideSpinner();
              this.commonService.errorToast('Order ID not received from server. Please try again.');
            }
          } else {
            this.flag = true;
            this.commonService.hideSpinner();
            console.error('Error in bookService response:', res ? JSON.stringify(res) : 'No response');
            this.commonService.errorToast((res && res.responseMessage) ? res.responseMessage : 'Failed to create order');
          }
        } catch (error) {
          this.flag = true;
          this.commonService.hideSpinner();
          console.error('Error processing bookService response:', error);
          console.error('Stack trace:', error.stack);
          this.commonService.errorToast('An unexpected error occurred while creating the order. Please try again.');
        }
      });
    } catch (error) {
      this.flag = true;
      this.commonService.hideSpinner();
      console.error('Exception in bookService:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An unexpected error occurred. Please try again.');
    }
  }
  OzhoUrl: any
  ozhoPayment() {
    try {
      console.log('Starting OZOW payment process');
      
      // Check if buyOrderData exists and has an _id property
      if (!this.buyOrderData || !this.buyOrderData._id) {
        console.error('Missing order data for OZOW payment');
        this.commonService.errorToast('Error processing payment: Missing order data');
        this.flag = true;
        this.commonService.hideSpinner();
        return;
      }
      
      console.log("Starting OZOW payment for order:", this.buyOrderData._id);
      
      // Set payment type for service bookings - important for the success page to redirect correctly
      localStorage.setItem('paymentMethod', 'OZOW');
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('isServiceBooking', 'true');
      
      let url = `order/ozowCheckOut?orderId=${this.buyOrderData._id}`;
      let data = {
        webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
        webError: this.commonService.webSiteUrl + 'customer-payment-error',
        webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
        testMode: false,
        trxFrom: 'WEB'
      };
      
      console.log('Sending OZOW payment request for order:', this.buyOrderData._id);
      
      this.commonService.postApi(url, data, 1).subscribe(
        (res: any) => {
          try {
            this.commonService.hideSpinner();
            console.log('Received OZOW payment response:', res ? JSON.stringify(res) : 'No response');
            
            if (!res) {
              console.error('Empty response from OZOW payment API');
              this.flag = true;
              this.commonService.errorToast('Error processing payment. Please try again.');
              return;
            }
            
            // Safely handle any arrays in the response
            if (res.result && Array.isArray(res.result)) {
              console.log('Result is an array with length:', res.result.length);
            }
            
            if (res.responseCode == 200) {
              if (res.result) {
                console.log('Processing OZOW redirect URL:', res.result);
                this.OzhoUrl = res.result;
                this.ozhoRedirect();
              } else {
                console.error('Invalid OZOW response format:', res);
                this.commonService.errorToast('Error processing payment. Please try again.');
                this.flag = true;
              }
            } else {
              this.flag = true;
              console.error('Error in OZOW payment response:', res);
              this.commonService.errorToast(res.responseMessage || 'Error processing OZOW payment');
            }
          } catch (error) {
            this.flag = true;
            this.commonService.hideSpinner();
            console.error('Error processing OZOW payment response:', error);
            console.error('Stack trace:', error.stack);
            this.commonService.errorToast('An unexpected error occurred during OZOW payment. Please try again.');
          }
        },
        (err) => {
          this.flag = true;
          this.commonService.hideSpinner();
          console.error('OZOW payment error:', err);
          this.commonService.errorToast(err && err.responseMessage ? err.responseMessage : 'Server error during OZOW payment');
        }
      );
    } catch (error) {
      this.flag = true;
      this.commonService.hideSpinner();
      console.error('Exception in ozhoPayment:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An unexpected error occurred. Please try again.');
    }
  }
  ozhoRedirect() {
    window.location.href = this.OzhoUrl
  }
  listAddressData: any = []
  listAddress() {
    let apiReqUrl = `user/listAddress`
    this.commonService.showSpinner();
    this.commonService.postApi(apiReqUrl, {}, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.listAddressData = res.result.docs;
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    })
  }
  addId: any
  isPrimary: any
  addressModals(id, prmy) {
    this.addId = id
    this.isPrimary = prmy
    $('#addressModal').modal('show')
  }

  deleteAddress() {
    let apiReqUrl = `user/deleteAddress?addressId=${this.addId}`
    if (this.isPrimary == true) {
      return this.commonService.errorToast('You can not delete primary address')

    } else {
      this.commonService.showSpinner();
      this.commonService.deleteApi(apiReqUrl, 1).subscribe((res: any) => {
        if (res.responseCode == 200) {
          // this.listAddressData = res.result.docs;
          $('#addressModal').modal('hide')
          this.listAddress()
          this.commonService.hideSpinner();
        } else {
          this.commonService.hideSpinner();
          this.commonService.errorToast(res.responseMessage)
        }
      })
    }
  }
  openListAddress() {
    $('#listAddressModal').modal('show')
  }
  toAddressId(id) {
    localStorage.setItem('primaryAddressId', id)
    $('#listAddressModal').modal('hide')

  }

  updateCartValue(actionType ?) {
    this.duration = ''

    actionType == 'ADD' ? ++this.quantityValue : --this.quantityValue;
    if (this.quantityValue == 0) {
      return this.commonService.infoToast('Product quabuyOrderntity can not be 0.')
    }
    console.log(this.quantityValue);

    this.getTotalProductPrice()
  }
  navigateToback() {
    this.router.navigate(['/customer-service-available-add'], { queryParams: { categoryId: this.catID, userId: this.UsID, categoryName: this.categoryName } })
  }
  slotData: any
  getQuantity(date) {
    let url = `service/makeSlots`
    let quantity = 0
    // for(let item of this.selectedService){
    //   for(let items of item.serviceArray){
    //     quantity = items.quantity+quantity

    //   }

    // }
    let startDate = ''
    let currentDate = new Date().toISOString().split('T')[0]
    let incommingDate = new Date(date).toISOString().split('T')[0]
    if (currentDate === incommingDate) {
      startDate = this.datePipe.transform(new Date(date).toLocaleString(), 'hh:mm')
    }
    else {
      startDate = '09:00'
    }
    quantity = this.selectedService.quantity + quantity
    let data = {
      userId: this.selectedService.userId._id,
      quantity: quantity,
      date: new Date(date).toLocaleString(),
      startDate: startDate
    }
    this.commonService.postApi(url, data, 0).subscribe((res: any) => {
      if (res.responseCode == 200) {
        this.slotData = res.result.docs
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage)
      }
    })
  }
  onImageLoad(){
    this.isLoaded = true
  }


  dropDownData = [
    {
      name: 'Proceed to book',
      value: ''
    },
    {
      name: 'OZOW Payment',
      value: 'OZOW'
    },
    {
      name: 'PayGate Payment',
      value: 'PAYGATE'
    },
    {
      name: 'YOCO Payment',
      value: 'YOCO'
    },
    {
      name: `Wallet`,
      value: 'WALLET'
    }
  ]
  walletPayment() {
    try {
      console.log('Starting wallet payment process');
      
      // Check if buyOrderData exists and has an _id property
      if (!this.buyOrderData || !this.buyOrderData._id) {
        console.error('Missing order data for wallet payment');
        this.commonService.errorToast('Error processing payment: Missing order data');
        this.flag = true;
        this.commonService.hideSpinner();
        return;
      }
      
      console.log('Order ID for wallet payment:', this.buyOrderData._id);
      
      // Check wallet balance
      if (this.totalPayAmount > this.myWalletBalance) {
        console.error('Insufficient wallet balance:', this.myWalletBalance, 'Required:', this.totalPayAmount);
        this.flag = true;
        this.commonService.hideSpinner();
        return this.commonService.errorToast('Insufficient fund in your wallet.');
      }
      
      console.log('Wallet balance:', this.myWalletBalance, 'Required amount:', this.totalPayAmount);
      
      // Set payment type for service bookings - important for the success page to redirect correctly
      localStorage.setItem('paymentMethod', 'WALLET');
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('isServiceBooking', 'true');
      
      let url = `order/checkOutWalletOrder?orderId=${this.buyOrderData._id}`;
      let data = {
        webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
        webError: this.commonService.webSiteUrl + 'customer-payment-error',
        webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
        cancelUrl: this.commonService.ozhoBaseUrl,
        errorUrl: this.commonService.ozhoBaseUrl,
        SuccessUrl: this.commonService.ozhoBaseUrl,
        testMode: true,
        trxFrom: 'WEB'
      };
      
      console.log('Sending wallet payment request for order:', this.buyOrderData._id);
      
      this.commonService.postApi(url, data, 1).subscribe(
        (res: any) => {
          try {
            this.commonService.hideSpinner();
            console.log('Received wallet payment response:', res ? JSON.stringify(res) : 'No response');
            
            if (!res) {
              console.error('Empty response from wallet payment API');
              this.flag = true;
              this.commonService.errorToast('Error processing payment. Please try again.');
              return;
            }
            
            // Safely handle any arrays in the response
            if (res.result && Array.isArray(res.result)) {
              console.log('Result is an array with length:', res.result.length);
            }
            
            if (res.responseCode == 200) {
              console.log('Wallet payment successful, redirecting to success page');
              this.router.navigate(['/customer-payment-success']);
            } else {
              this.flag = true;
              console.error('Error in wallet payment response:', res);
              this.commonService.errorToast(res.responseMessage || 'Error processing wallet payment');
            }
          } catch (error) {
            this.flag = true;
            this.commonService.hideSpinner();
            console.error('Error processing wallet payment response:', error);
            console.error('Stack trace:', error.stack);
            this.commonService.errorToast('An unexpected error occurred during wallet payment. Please try again.');
          }
        },
        (err) => {
          this.flag = true;
          this.commonService.hideSpinner();
          console.error('Wallet payment error:', err);
          this.commonService.errorToast(err && err.responseMessage ? err.responseMessage : 'Server error during wallet payment');
        }
      );
    } catch (error) {
      this.flag = true;
      this.commonService.hideSpinner();
      console.error('Exception in walletPayment:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An unexpected error occurred. Please try again.');
    }
  }
  myWalletBalance: any = 0
  myWallet() {
    try {
      console.log('Starting myWallet method');
      
      // Store method execution state
      this.debugState.myWalletCalled = {
        timestamp: new Date().toISOString()
      };
      
      const url = `deliveryOrders/getWalletTransaction?isCommission=true&page=1&limit=1`;
      
      this.commonService.showSpinner();
      this.commonService.getApi(url, 1).subscribe(
        (res: any) => {
          try {
            console.log('Received wallet info response:', res ? JSON.stringify(res) : 'No response');
            
            // Store response in debug state
            this.debugState.myWalletResponse = {
              response: res,
              timestamp: new Date().toISOString()
            };
            
            if (res && res.responseCode == 200) {
              this.commonService.hideSpinner();
              
              // Safely access nested properties
              if (res.result && res.result.wallet && res.result.wallet.walletAmount !== undefined) {
                const walletBalance = parseFloat(res.result.wallet.walletAmount).toFixed(2);
                console.log('Wallet balance:', walletBalance);
                
                // Build dropdown data array safely
                this.dropDownData = [
                  { name: 'Proceed to book', value: '' },
                  { name: 'OZOW Payment', value: 'OZOW' },
                  { name: 'PayGate Payment', value: 'PAYGATE' },
                  { name: 'YOCO Payment', value: 'YOCO' },
                  { name: `Wallet (R ${walletBalance})`, value: 'WALLET' }
                ];
                
                // Store wallet balance
                this.myWalletBalance = res.result.wallet.walletAmount;
              } else {
                console.error('Missing wallet data in response:', res);
                // Use default dropdown data
                this.dropDownData = [
                  { name: 'Proceed to book', value: '' },
                  { name: 'OZOW Payment', value: 'OZOW' },
                  { name: 'PayGate Payment', value: 'PAYGATE' },
                  { name: 'YOCO Payment', value: 'YOCO' },
                  { name: 'Wallet', value: 'WALLET' }
                ];
                this.myWalletBalance = 0;
              }
            } else {
              this.commonService.hideSpinner();
              console.error('Error in wallet info response:', res ? JSON.stringify(res) : 'No response');
              // Use default dropdown data
              this.dropDownData = [
                { name: 'Proceed to book', value: '' },
                { name: 'OZOW Payment', value: 'OZOW' },
                { name: 'PayGate Payment', value: 'PAYGATE' },
                { name: 'YOCO Payment', value: 'YOCO' },
                { name: 'Wallet', value: 'WALLET' }
              ];
              this.myWalletBalance = 0;
            }
          } catch (error) {
            this.commonService.hideSpinner();
            console.error('Error processing wallet info response:', error);
            console.error('Stack trace:', error.stack);
            
            // Use default dropdown data in case of error
            this.dropDownData = [
              { name: 'Proceed to book', value: '' },
              { name: 'OZOW Payment', value: 'OZOW' },
              { name: 'PayGate Payment', value: 'PAYGATE' },
              { name: 'YOCO Payment', value: 'YOCO' },
              { name: 'Wallet', value: 'WALLET' }
            ];
            this.myWalletBalance = 0;
          }
        },
        (err) => {
          this.commonService.hideSpinner();
          console.error('Error fetching wallet info:', err);
          
          // Use default dropdown data in case of error
          this.dropDownData = [
            { name: 'Proceed to book', value: '' },
            { name: 'OZOW Payment', value: 'OZOW' },
            { name: 'PayGate Payment', value: 'PAYGATE' },
            { name: 'YOCO Payment', value: 'YOCO' },
            { name: 'Wallet', value: 'WALLET' }
          ];
          this.myWalletBalance = 0;
        }
      );
    } catch (error) {
      this.commonService.hideSpinner();
      console.error('Exception in myWallet:', error);
      console.error('Stack trace:', error.stack);
      
      // Use default dropdown data in case of error
      this.dropDownData = [
        { name: 'Proceed to book', value: '' },
        { name: 'OZOW Payment', value: 'OZOW' },
        { name: 'PayGate Payment', value: 'PAYGATE' },
        { name: 'YOCO Payment', value: 'YOCO' },
        { name: 'Wallet', value: 'WALLET' }
      ];
      this.myWalletBalance = 0;
    }
  }
  selectPayment(e) {
    try {
      console.log('Payment method selected:', e);
      
      // First validate that we have time slots and duration
      if (!this.timeSlots || !this.duration) {
        console.error('Missing time slot or duration');
        return this.commonService.errorToast('Please select date and time slot');
      }

      // Validate selected service with detailed diagnostics
      if (!this.selectedService) {
        console.error('selectedService is undefined in selectPayment');
        return this.commonService.errorToast('Service details not available. Please refresh the page and try again.');
      }
      
      console.log('selectedService details:', JSON.stringify(this.selectedService));
      
      if (!this.selectedService.serviceId) {
        console.error('serviceId is undefined in selectedService');
        return this.commonService.errorToast('Service ID not available. Please refresh the page and try again.');
      }
      
      if (!this.selectedService.serviceId._id) {
        console.error('serviceId._id is undefined in selectedService');
        return this.commonService.errorToast('Service ID not available. Please refresh the page and try again.');
      }

      // Validate address
      if (!this.addressId) {
        console.error('addressId is undefined in selectPayment');
        return this.commonService.errorToast('Please select an address before proceeding.');
      }

      // Prepare data for logging (safely)
      const diagnosticData = {
        paymentMethod: e,
        timeSlots: this.timeSlots,
        duration: this.duration,
        addressId: this.addressId,
        selectedServiceId: this.selectedService && this.selectedService.serviceId ? this.selectedService.serviceId._id : 'undefined',
        serviceQuantity: this.selectedService ? this.selectedService.quantity : 'undefined',
        dealId: this.selectedService ? this.selectedService._id : 'undefined'
      };
      
      console.log('Diagnostic data before calling payment service:', diagnosticData);
      
      // Show some processing indicator without disabling the UI
      this.commonService.showSpinner();
      
      // Call appropriate payment method based on selection
      try {
        if (e == 'OZOW') {
          console.log('Calling OZOW payment with flag 1');
          this.bookService(1);
        } else if (e == 'WALLET') {
          console.log('Calling wallet payment with flag 2');
          this.bookService(2);
        } else if (e == 'YOCO') {
          // Store the current timestamp and order ID in localStorage to identify this specific order
          localStorage.setItem('orderTimestamp', new Date().toISOString());
          localStorage.setItem('paymentMethod', 'YOCO');
          
          // Set a flag to indicate we're about to process a Yoco payment
          // This will help the success page know to update the order status
          localStorage.setItem('from_yoco_payment', 'true');
          
          console.log('Calling Yoco payment with flag 4');
          this.bookService(4);
        } else if (e == 'PAYGATE') {
          // Store payment information for transaction history
          localStorage.setItem('paymentList', 'booking');
          localStorage.setItem('paymentMethod', 'PAYGATE');
          localStorage.setItem('orderTimestamp', new Date().toISOString());
          localStorage.setItem('from_paygate_payment', 'true');
          
          console.log('Calling PayGate payment with flag 3');
          this.bookService(3);
        } else {
          console.error('Invalid payment method selected:', e);
          this.commonService.hideSpinner();
          this.commonService.errorToast('Invalid payment method. Please try again.');
        }
      } catch (innerError) {
        console.error('Error calling payment method:', innerError);
        console.error('Stack trace:', innerError.stack);
        this.commonService.hideSpinner();
        this.commonService.errorToast('An error occurred while processing your payment. Please try again.');
      }
    } catch (error) {
      console.error('Exception in selectPayment:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.hideSpinner();
      this.commonService.errorToast('An unexpected error occurred while processing your payment selection. Please try again.');
    }
  }

  htmlData: any
  paygatePayment() {
    try {
      console.log('Starting PayGate payment process');
      
      // Check if buyOrderData exists and has an _id property
      if (!this.buyOrderData || !this.buyOrderData._id) {
        console.error('Missing order data for PayGate payment');
        this.commonService.errorToast('Error processing payment: Missing order data');
        this.flag = true;
        this.commonService.hideSpinner();
        return;
      }
      
      console.log("Starting PayGate payment for order:", this.buyOrderData._id);
      
      // Set payment type for service bookings - important for the success page to redirect correctly
      localStorage.setItem('paymentMethod', 'PAYGATE');
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('isServiceBooking', 'true');
      
      let url = `payment/checkoutPayGate?orderId=${this.buyOrderData._id}`;
      let data = {
        webFailure: this.commonService.webSiteUrl + 'customer-payment-cancel',
        webError: this.commonService.webSiteUrl + 'customer-payment-error',
        webSuccess: this.commonService.webSiteUrl + 'customer-payment-success',
        cancelUrl: this.commonService.ozhoBaseUrl,
        errorUrl: this.commonService.ozhoBaseUrl,
        SuccessUrl: this.commonService.ozhoBaseUrl,
        testMode: false,
        trxFrom: 'WEB'
      };
      
      console.log('Sending PayGate payment request for order:', this.buyOrderData._id);
      
      this.commonService.postApi(url, data, true).subscribe(
        (res: any) => {
          try {
            this.commonService.hideSpinner();
            console.log('Received PayGate payment response:', res ? JSON.stringify(res) : 'No response');
            
            if (!res) {
              console.error('Empty response from PayGate payment API');
              this.flag = true;
              this.commonService.errorToast('Error processing payment. Please try again.');
              return;
            }
            
            // Safely handle any arrays in the response
            if (res.result && Array.isArray(res.result)) {
              console.log('Result is an array with length:', res.result.length);
            }
            
            if (res.responseCode == 200) {
              if (res.result && res.result.file) {
                console.log('Processing PayGate HTML form');
                this.htmlData = this.sanatizer.bypassSecurityTrustHtml(res.result.file);
                
                // Find and submit the form
                setTimeout(() => {
                  const form = document.getElementById('paygate-form');
                  if (form) {
                    console.log('Submitting PayGate form');
                    (form as HTMLFormElement).submit();
                  } else {
                    console.error('PayGate form not found in response');
                    this.commonService.errorToast('Error processing payment. Please try again.');
                    this.flag = true;
                  }
                }, 500);
              } else {
                console.error('Invalid PayGate response format:', res.result ? JSON.stringify(res.result) : 'No result.file property');
                this.commonService.errorToast('Error processing payment. Please try again.');
                this.flag = true;
              }
            } else {
              this.flag = true;
              console.error('Error in PayGate payment response:', res);
              this.commonService.errorToast(res.responseMessage || 'Error processing PayGate payment');
            }
          } catch (error) {
            this.flag = true;
            this.commonService.hideSpinner();
            console.error('Error processing PayGate payment response:', error);
            console.error('Stack trace:', error.stack);
            this.commonService.errorToast('An unexpected error occurred during PayGate payment. Please try again.');
          }
        },
        (err) => {
          this.flag = true;
          this.commonService.hideSpinner();
          console.error('PayGate payment error:', err);
          this.commonService.errorToast(err && err.responseMessage ? err.responseMessage : 'Server error during PayGate payment');
        }
      );
    } catch (error) {
      this.flag = true;
      this.commonService.hideSpinner();
      console.error('Exception in paygatePayment:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An unexpected error occurred. Please try again.');
    }
  }
  serviceList = []
  openModal() {
    try {
      $('#intrestedPriceModal').modal('show');
      
      // Safely retrieve and parse selectedService from sessionStorage
      try {
        const serviceData = sessionStorage.getItem('selectedService');
        if (serviceData) {
          this.serviceList = JSON.parse(serviceData);
          console.log("Successfully loaded service list for modal:", this.serviceList);
        } else {
          console.error("No selectedService found in sessionStorage for modal");
          this.serviceList = [];
          this.commonService.errorToast('Service details not available. Please try again.');
        }
      } catch (error) {
        console.error("Error parsing selectedService from sessionStorage for modal:", error);
        this.serviceList = [];
        this.commonService.errorToast('Error loading service details. Please try again.');
      }
    } catch (error) {
      console.error("Error in openModal:", error);
      this.commonService.errorToast('An error occurred while opening the modal. Please try again.');
    }
  }
  // _categoryId 
  _serviceId
  subServiceList: any = []

  servicePrice
  _discountedPrice
  startCampaign(){
    if(this._discountedPrice === "0"){
      this.commonService.errorToast("Interested Price cannot be 0 ")
      return;
    }
    console.log("start")
    // console.log(this._categoryId,"categoryId")
    let data = {
     
      serviceId: this.selectedService.serviceId._id,
      price: `${this.selectedService.serviceId.price}`,
      interestedPrice: this._discountedPrice,
      spordicType: this.spordicType
    }
    console.log(data);
    let url = `campaign/addIntrestPriceOnService`

    this.commonService.postApi(url, data, 1).subscribe((res: any) => {
      if (res.responseCode == 200) {
        // this.commonService.successToast(res.responseMessage);
        this.toastrService.success("Intrested price added successfully");
        $('#intrestedPriceModal').modal('hide')
        this.commonService.hideSpinner();
      } else {
        this.commonService.hideSpinner();
        this.commonService.errorToast(res.responseMessage);
      }
    })
  }
  getSubCatList(e) {
    try {
      console.log("Category ID:", e);
      
      // Check if serviceList exists and is an array
      if (!this.serviceList || !Array.isArray(this.serviceList)) {
        console.error("serviceList is undefined or not an array");
        this.commonService.errorToast('Service list not available. Please try again.');
        return;
      }
      
      console.log("Service list:", this.serviceList);
      
      // Use safe find operation with error handling
      let found = false;
      let foundItem = null;
      
      try {
        foundItem = this.serviceList.find((ele) => {
          if (!ele || !ele.serviceId || !ele.serviceId.categoryId) {
            return false;
          }
          return ele.serviceId.categoryId._id === e;
        });
        
        if (foundItem) {
          found = true;
        }
      } catch (err) {
        console.error("Error in find operation:", err);
      }
      
      if (!found || !foundItem) {
        console.error("No matching service found for category ID:", e);
        this.subServiceList = [];
        return;
      }
      
      console.log("Found service:", foundItem);
      
      // Safely access serviceArray
      if (foundItem.serviceArray && Array.isArray(foundItem.serviceArray)) {
        this.subServiceList = foundItem.serviceArray;
        console.log("Sub-service list:", this.subServiceList);
      } else {
        this.subServiceList = [];
        console.warn("serviceArray is undefined or not an array");
      }
    } catch (error) {
      console.error("Error in getSubCatList:", error);
      this.subServiceList = [];
      this.commonService.errorToast('An error occurred while loading service categories. Please try again.');
    }
  }
  getPriceService(e) {
    try {
      console.log("Selected subCategory ID:", e);
      
      // Check if subServiceList exists and is an array
      if (!this.subServiceList || !Array.isArray(this.subServiceList)) {
        console.error("subServiceList is undefined or not an array");
        this.commonService.errorToast('Service details not available. Please try again.');
        return;
      }
      
      // Use safe find operation with error handling
      let found = false;
      let foundItem = null;
      
      try {
        foundItem = this.subServiceList.find((ele) => {
          if (!ele || !ele.subCategoryId) {
            return false;
          }
          return ele.subCategoryId === e;
        });
        
        if (foundItem) {
          found = true;
        }
      } catch (err) {
        console.error("Error in find operation:", err);
      }
      
      if (!found || !foundItem) {
        console.error("No matching sub-service found for ID:", e);
        this.servicePrice = 0;
        return;
      }
      
      // Safely access price property
      if (foundItem.price !== undefined) {
        this.servicePrice = foundItem.price;
        console.log("Service price:", this.servicePrice);
      } else {
        this.servicePrice = 0;
        console.warn("Price is undefined for the selected service");
      }
    } catch (error) {
      console.error("Error in getPriceService:", error);
      this.servicePrice = 0;
      this.commonService.errorToast('An error occurred while loading service price. Please try again.');
    }
  }

  yocoPayment() {
    try {
      console.log('Starting Yoco payment process');
      
      // Check if buyOrderData exists and has an _id property
      if (!this.buyOrderData || !this.buyOrderData._id) {
        console.error('Missing order data for Yoco payment');
        this.commonService.errorToast('Error processing payment: Missing order data');
        this.flag = true;
        this.commonService.hideSpinner();
        return;
      }
      
      console.log('Order ID:', this.buyOrderData._id);
      
      // Additional logging to check payment amount
      if (this.buyOrderData && this.buyOrderData.orderPrice) {
        console.log('Order Price before Yoco payment:', this.buyOrderData.orderPrice);
      }
      
      // Store payment method and order ID in localStorage so success page knows which order to update
      localStorage.setItem('paymentMethod', 'YOCO');
      localStorage.setItem('lastOrderId', this.buyOrderData._id);
      localStorage.setItem('orderTimestamp', new Date().toISOString());
      localStorage.setItem('from_yoco_payment', 'true');
      
      // Set payment type for service bookings - important for the success page to redirect correctly
      localStorage.setItem('paymentList', 'booking');
      localStorage.setItem('isServiceBooking', 'true');
      
      let url = `payment/checkoutYoco?orderId=${this.buyOrderData._id}`;
      let data = {
        webFailure: `${window.location.origin}/customer-payment-cancel`,
        webError: `${window.location.origin}/customer-payment-error`,
        webSuccess: `${window.location.origin}/customer-payment-success?orderId=${this.buyOrderData._id}`,
        cancelUrl: `${window.location.origin}/customer-payment-cancel`,
        errorUrl: `${window.location.origin}/customer-payment-error`,
        successUrl: `${window.location.origin}/customer-payment-success?orderId=${this.buyOrderData._id}`,
        testMode: true,
        trxFrom: 'WEB'
      };
      
      console.log('Sending request to backend:', this.commonService.baseUrl + url);
      console.log('With data:', JSON.stringify(data));
      
      // Call our backend API to create the Yoco checkout
      this.commonService.postApi(url, data, 1).subscribe(
        (res: any) => {
          try {
            console.log('Received response from backend:', JSON.stringify(res));
            this.commonService.hideSpinner();
            
            if (!res) {
              console.error('Empty response from Yoco payment API');
              this.flag = true;
              this.commonService.errorToast('Error processing payment. Please try again.');
              return;
            }
            
            // Safely handle any arrays in the response
            if (res.result && Array.isArray(res.result)) {
              console.log('Result is an array with length:', res.result.length);
            }
            
            if (res && (res.responseCode == 200 || res.responseCode == 'SUCCESS')) {
              // Check if the response contains a redirect URL or HTML form
              if (res.result && res.result.checkoutUrl) {
                // If we have a direct redirect URL, use it
                console.log('Redirecting to Yoco checkout URL:', res.result.checkoutUrl);
                window.location.href = res.result.checkoutUrl;
                return;
              } else if (res.result && res.result.file) {
                // If we have an HTML form, render it in the DOM
                console.log('Rendering HTML form from response');
                try {
                  // Create a container for the form
                  const formContainer = document.createElement('div');
                  formContainer.innerHTML = res.result.file;
                  document.body.appendChild(formContainer);
                  
                  // Find and submit the form
                  setTimeout(() => {
                    const form = document.getElementById('yoco-form');
                    if (form) {
                      console.log('Submitting Yoco form');
                      (form as HTMLFormElement).submit();
                    } else {
                      console.error('Yoco form not found in response');
                      this.commonService.errorToast('Error processing payment. Please try again.');
                      this.flag = true; // Re-enable buttons
                    }
                  }, 500);
                } catch (error) {
                  console.error('Error rendering HTML form:', error);
                  this.commonService.errorToast('Error processing payment. Please try again.');
                  this.flag = true; // Re-enable buttons
                }
              } else {
                console.error('Invalid Yoco response format:', res.result ? JSON.stringify(res.result) : 'Missing checkout URL or form');
                this.commonService.errorToast('Error processing payment. Please try again.');
                this.flag = true;
              }
            } else {
              this.flag = true;
              console.error('Error in Yoco payment response:', res);
              this.commonService.errorToast(res.responseMessage || 'Error processing Yoco payment');
            }
          } catch (error) {
            this.flag = true;
            this.commonService.hideSpinner();
            console.error('Error processing Yoco payment response:', error);
            console.error('Stack trace:', error.stack);
            this.commonService.errorToast('An unexpected error occurred during Yoco payment. Please try again.');
          }
        },
        (err) => {
          this.flag = true;
          this.commonService.hideSpinner();
          console.error('Yoco payment error:', err);
          this.commonService.errorToast(err && err.responseMessage ? err.responseMessage : 'Server error during Yoco payment');
        }
      );
    } catch (error) {
      this.flag = true;
      this.commonService.hideSpinner();
      console.error('Exception in yocoPayment:', error);
      console.error('Stack trace:', error.stack);
      this.commonService.errorToast('An unexpected error occurred. Please try again.');
    }
  }
}
